import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APPROVAL_PALETTE } from '@/theme/palette';

/** "참조인 추가 및 참조메일 발송" 모달 styled */
export const SendButton = styled('button')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 8,
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'Pretendard, sans-serif',
  fontWeight: 400,
  whiteSpace: 'nowrap',
  flexShrink: 0,
  padding: 12,
  gap: 4,
  minWidth: 80,
  fontSize: 14,
  lineHeight: '20px',
  background: '#0066CC',
  color: '#FFFFFF',
  '&:hover': { background: '#3385D6' },
  '&:active': { background: '#1A75D1' },
  '&:disabled': {
    background: 'var(--dk-accent-tint, #C2DAF3)',
    color: '#FFFFFF',
    cursor: 'default',
    pointerEvents: 'none',
  },
  '& .btn__label': { padding: '0 4px' },
}));

/** 메시지 입력 셸 */
export const EditorShell = styled(Box)(() => ({
  position: 'relative',
}));

/** 참조메일 메시지 textarea */
export const MessageTextarea = styled('textarea')(({ theme }) => ({
  width: '100%',
  minHeight: 100,
  boxSizing: 'border-box',
  resize: 'vertical',
  padding: '10px 12px 28px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  fontFamily: 'Pretendard, sans-serif',
  fontSize: 14,
  lineHeight: '20px',
  color: theme.palette.text.primary,
  outline: 'none',
  '&::placeholder': { color: theme.palette.text.disabled },
  '&:focus': { borderColor: APPROVAL_PALETTE.primary.main },
  '&:disabled': {
    background: theme.palette.action.disabledBackground,
    cursor: 'default',
  },
}));

export const CharCount = styled('span')(({ theme }) => ({
  position: 'absolute',
  right: 12,
  bottom: 10,
  padding: '0 4px',
  background: theme.palette.common.white,
  fontSize: 12,
  lineHeight: '16px',
  color: theme.palette.text.disabled,
  pointerEvents: 'none',
  '&.over': { color: APPROVAL_PALETTE.error.main },
}));
